import React from "react";
import {useFormContext} from "react-hook-form";

import { Transfer } from 'antd';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';

import * as CustomStyles from '../styles/CustomStyles';
import * as ValidationMessages from '../constants/ValidationMessages';
import * as TypeConvertor from '../util/TypeConvertor';
import * as AFUtility from '../util/AFUtility';

//
// It is expected that <FormProvider> provides all the hook methods in the parent before calling the below components
// The components access the methods (register, formState, errors, etc...) by using useFormContext()
// lSubcontractor is expected to be in the local form state
//

export function RenderGeneralSection(props) {
    console.log('Sectiune Generala...');
    const { register, setValue, getValues, trigger, watch, formState: { errors, defaultValues } } = useFormContext();

    const [checkedActive, setCheckedActive] = React.useState(!!defaultValues.lSubcontractor.generalSection.active ? defaultValues.lSubcontractor.generalSection.active : false);

    const [subcontractorClients, setSubcontractorClients] = React.useState( TypeConvertor.getClientSelectData(props.clients) );
    const [selectedSubconClientId, setSelectedSubconClientId] = React.useState( defaultValues.lSubcontractor.generalSection.clientId ? defaultValues.lSubcontractor.generalSection.clientId : '' );

    const [xferSourceData, setXferSourceData] = React.useState([]);
    const [xferTargetKeys, setXferTargetKeys] = React.useState([]);    

    const setWorksiteTData = () => {
        var tempTargetKeys = [];
        const tempSourcekData = [];

        props.worksites.forEach(worksite => {
            const employer = props.employers.find(employer => employer.id === worksite.generalSection.employerId)
            const erName = employer ? employer.generalSection.employerName : 'NA';
            const wsDec = erName + ' - '
                + worksite.generalSection.name + ', '
                + worksite.generalSection.judet + ', '
                + worksite.generalSection.localitate;
            const data = {
                // key: worksite.id.toString(),
                key: worksite.generalSection.employerId + '#' + worksite.id,
                title: wsDec,
                description: wsDec,
                chosen: false,
            };
            tempSourcekData.push(data);
        })

        if (!!defaultValues.lSubcontractor.generalSection.permissionedWS) {
            tempTargetKeys = defaultValues.lSubcontractor.generalSection.permissionedWS;
        }
        else{
            setValue("lSubcontractor.generalSection.permissionedWS", tempTargetKeys);    
        }

        setXferSourceData(tempSourcekData);
        setXferTargetKeys(tempTargetKeys);
    };

    
    const handleTransferChange = (newTargetKeys) => {
        setXferTargetKeys(newTargetKeys);
        setValue("lSubcontractor.generalSection.permissionedWS", newTargetKeys);

        // for convenience, store the Employer IDs
        var mySet = new Set(); 
        newTargetKeys.forEach((wsKeyId) => {
            if(!AFUtility.isString(wsKeyId) || !wsKeyId.includes('#')) 
                return;
            const wsId = parseInt(wsKeyId.split('#')[1]);
            props.worksites
                .filter(worksite => worksite.id === wsId )
                .forEach(worksite => mySet.add(worksite.generalSection.employerId));

        })
        setValue("lSubcontractor.generalSection.permissionedER", Array.from(mySet));
    };

    React.useEffect(() => {
        setWorksiteTData();
    }, []);      


    const handleClientChange = (clientId) => {
        setSelectedSubconClientId(clientId);
    }

    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={4}>
                    <FormControl fullWidth size="small" margin="dense" variant="standard" disabled={!!defaultValues.lSubcontractor.id}>
                        <InputLabel id={'daClient-inputLabelId'} error={!!errors?.lSubcontractor?.generalSection?.clientId}>Client</InputLabel>
                        <Select
                            {...register('lSubcontractor.generalSection.clientId', {required: ValidationMessages.REQUITED_MESSAGE})}
                            labelId={'daClient-selectLabelId'}
                            id={'daClient'}
                            value={selectedSubconClientId}
                            onChange={(event) => handleClientChange(event.target.value) }
                            label={'daClient-label'}
                            error={!!errors?.lSubcontractor?.generalSection?.clientId}
                            >
                            {
                                subcontractorClients.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                            }
                        </Select>
                        <Typography sx={{ color: 'error.main', fontSize: 12 }}>{errors?.lSubcontractor?.generalSection?.clientId ? errors.lSubcontractor.generalSection.clientId.message : null}</Typography>
                    </FormControl>
                </Grid>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={5}>
                    <FormControlLabel 
                        control={ 
                            <Checkbox
                                {...register('lSubcontractor.generalSection.active')}                         
                                checked={checkedActive} 
                                onChange={(event) => setCheckedActive(event.target.checked)}
                            /> 
                        } 
                        label="Activ" 
                    />
                </Grid>

                {/*row*/}
                <Grid item xs={12}>
                    <Transfer
                        dataSource={xferSourceData}
                        showSearch
                        listStyle={{
                            width: '100%',
                            height: 300,
                        }}
                        targetKeys={xferTargetKeys}
                        onChange={handleTransferChange}
                        render={(item) => item.title}
                    />
                </Grid>

            </Grid>
        </Box>
    );
}

